module.exports = __webpack_public_path__ + "img/2.39121fc9.jpeg";